export default function anchorLinkHolder() {
  const holder = document.querySelector('.js-anchor-link-holder');

  if ( holder ) {
    const screen = window.screen.height / 2;
    const innerLink = holder.querySelector('.page-anchor-link');
    const linkLocation = innerLink.getAttribute('href');
    const pageLocation = window.location.href;
    
    function init() {
        const top = window.scrollY;

        if (linkLocation === pageLocation) {
          holder.style.display = 'none';
        }

        if (top >= screen) {
          holder.classList.add('show');
        } else {
          holder.classList.remove('show');
        }
      }

      window.addEventListener('scroll', init);
      init();
    }
}
